<template>
  <div>
    <!-- 标题和年度选择器容器 -->
    <div class="header-container">
      <h3 class="chart-title">每月客户增长趋势</h3>
      <el-select v-model="selectedYear" placeholder="请选择年度" @change="updateChart">
        <el-option
            v-for="year in yearOptions"
            :key="year"
            :label="`${year}年度`"
            :value="year"
        />
      </el-select>
    </div>

    <!-- 加载动画 -->
    <el-loading v-if="loading">加载中...</el-loading>

    <!-- 图表区域 -->
    <div id="customer-trend-chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'CustomerTrendChart',
  data() {
    return {
      chart: null, // ECharts 实例
      selectedYear: new Date().getFullYear(), // 默认当前年度
      yearOptions: this.getYearOptions(), // 可选年度列表
      customerData: [], // 存储后端返回的数据
      loading: false, // 是否显示加载动画
    };
  },
  mounted() {
    this.initChart();
    this.updateChart();
  },
  methods: {
    // 获取年度选项
    getYearOptions() {
      const startYear = 2024; // 起始年度
      const currentYear = new Date().getFullYear();
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    },

    // 初始化图表
    initChart() {
      this.chart = echarts.init(document.getElementById('customer-trend-chart'));
    },

    // 更新图表（请求后端数据）
    updateChart() {
      const logininfo = JSON.parse(localStorage.getItem("logininfo"));
      const logininfoId = logininfo.id;
      const year = this.selectedYear;

      this.loading = true;
      this.$http.get("/employeeRanking/customer", {
        params: { year, logininfoId },
      }).then(response => {
        this.customerData = response.data; // 假设后端返回的数据为数组
        this.renderChart();
      }).catch(error => {
        console.error('Error fetching data:', error);
      }).finally(() => {
        this.loading = false;
      });
    },

    // 渲染图表
    renderChart() {
      const { xAxisData, seriesData } = this.formatData();

      const option = {
        title: {
          text: `${this.selectedYear} 年度客户增长趋势`,
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
        },
        legend: {
          data: ['新增客户'],
          bottom: 0,
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: '月份',
        },
        yAxis: {
          type: 'value',
          name: '新增客户数量',
        },
        series: [
          {
            name: '新增客户',
            type: 'line',
            smooth: true,
            data: seriesData,
            lineStyle: { color: '#5470C6' },
          },
        ],
      };

      this.chart.setOption(option);
    },

    // 格式化后端返回的数据
    formatData() {
      const xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

      // 初始化数据（所有月份默认 0）
      const seriesData = Array(12).fill(0);

      // 填充后端数据
      if (this.customerData) {
        this.customerData.forEach(item => {
          const month = item.month - 1; // 获取月份索引（数据库 1-12，但数组索引是 0-11）
          seriesData[month] = item.customers; // 存储每月新增客户数
        });
      }

      return { xAxisData, seriesData };
    },
  },
};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between; /* 左右分布 */
  align-items: center; /* 垂直居中 */
  margin-bottom: 16px; /* 与图表的间距 */
}

.chart-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

#customer-trend-chart {
  width: 100%;
  height: 400px;
}

.el-select {
  width: 200px;
}

.el-loading {
  text-align: center;
  font-size: 16px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// mydateCustomer.vue?f1718ede